import { X } from "@mui/icons-material"
import { Box, Button, Container, Link as MuiLink, Stack, Typography } from "@mui/material"
import React from "react"

import { AFLogo } from "./AFLogo"
import { DiscordLogo } from "./DiscordLogo"
import ENV from "../../env"

export function Footer() {
  return (
    <Container maxWidth="xl">
      <Stack gap={4} sx={{ paddingY: 2 }}>
        <Box
          sx={{
            display: {
              xs: "flex",
              md: "grid",
            },
            flexDirection: {
              xs: "column",
            },
            gridTemplateColumns: {
              md: "1fr auto 1fr",
            },
            alignItems: "center",
            gap: 2,
          }}
        >
          <Stack
            direction="row"
            gap={1}
            alignItems="center"
            sx={{ color: "var(--mui-palette-text-secondary)" }}
          >
            <MuiLink
              target="_blank"
              href="https://dexi.defi.ao/"
              underline="hover"
              variant="body2"
              sx={{ color: "var(--mui-palette-text-secondary)" }}
            >
              Dexi
            </MuiLink>
            •{" "}
            <MuiLink
              target="_blank"
              href="https://coin.defi.ao/"
              underline="hover"
              variant="body2"
              sx={{ color: "var(--mui-palette-text-secondary)" }}
            >
              CoinMaker
            </MuiLink>
            •{" "}
            <MuiLink
              target="_blank"
              href="https://docs.autonomous.finance/products/platforms/botega"
              underline="hover"
              variant="body2"
              sx={{ color: "var(--mui-palette-text-secondary)" }}
            >
              Documentation
            </MuiLink>
          </Stack>
          <Stack direction="row" gap={1}>
            <Typography component="span" sx={{ color: "rgb(180, 180, 180)" }} variant="caption">
              Powered by
            </Typography>
            <Button
              href="https://autonomous.finance"
              target="_blank"
              variant="text"
              sx={{ padding: 0 }}
            >
              <AFLogo color="var(--mui-palette-text-primary)" />
              <Typography
                variant="body2"
                sx={{
                  color: "var(--mui-palette-text-secondary)",
                  marginLeft: 1,
                  textTransform: "uppercase",
                }}
              >
                autonomous.finance
              </Typography>
            </Button>
          </Stack>
          <Stack gap={3} direction="row" alignItems="center" sx={{ justifySelf: "flex-end" }}>
            <Typography variant="caption" color="text.secondary">
              v{(ENV.VITE_APP_VER as any)?.replaceAll('"', "")} ·{" "}
              {ENV.VITE_GIT_HASH?.substring(0, 6)}
            </Typography>
            <MuiLink
              target="_blank"
              href="https://discord.com/invite/AK6C2PPWDc"
              underline="hover"
              variant="body2"
              sx={{ color: "rgba(160,160,160,1)" }}
            >
              <DiscordLogo width={24} height={24} />
            </MuiLink>
            <MuiLink
              target="_blank"
              href="https://x.com/Botega_AF"
              underline="hover"
              variant="body2"
              sx={{ color: "rgba(160,160,160,1)" }}
            >
              <X />
            </MuiLink>
          </Stack>
        </Box>
      </Stack>
    </Container>
  )
}
